import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Container, Row, Col, Button, Card, Image, Alert } from 'react-bootstrap';
import CompanyLayout from '../layouts/CompanyLayout';
import HRA from '../components/employee-benefits/HRA';
import FSA from '../components/employee-benefits/FSA'
import LSA from '../components/employee-benefits/LSA'
import EmployeeBenefitsService from '../services/employeeBenefitsService';
import GeneralInfo from '../components/employee-benefits/GeneralInfo';
import Enrollment from '../components/employee-benefits/Enrollment';
import config from '../config';
import { ebSubmittedAlert, saveAlert } from '../alerts/Alerts';
import ChangeContact from '../components/ChangeContact';
import Layout from '../layouts/Layout';
import ClarityLogo from '../assets/images/clarity-logo.png';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import SurveyMonkey from '../services/SurveyMonkey';



function EmployeeBenefits({ onError = () => {} }) {
  const { caseId } = useParams();
  const [renewalCase, setRenewalcase] = useState([]);
  const navigate = useNavigate();
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [showValidationMessage, setShowValidationMessage] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [username, setUsername] = useState(sessionStorage.getItem('username'));
  const [decodedToken, setDecodedToken] = useState(sessionStorage.getItem('decodedToken'));
  const [bearerToken, setBearerToken] = useState(sessionStorage.getItem('bearerToken'));
  
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  const [informationProvider, setInformationProvider] = useState('');

  const hraRef = useRef();
  const lsaRef = useRef();
  const generalInfoRef = useRef();
  const enrollmentRef = useRef();
  const fsaRef = useRef();

  useEffect(() => {
    const fetchcase = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/RenewalCases/${caseId}`);
        setRenewalcase(response.data);
      } catch (error) {
        console.error('Error fetching cases:', error);
      }
    };
    fetchcase();
  }, []);

  
 
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get("showPopup") === "true") {
      setShowPopup(true);
    }
  }, [location]);
 
  const handleCloseModalOne = () => {
    setShowPopup(false);
  };


  const handleError = (error) => {
    setSubmitError('There was an error updating the form. Please try again.');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError(null);
    setSubmitSuccess(false);
    setShowValidationMessage(false);
 
    try {
      //await fetchPlans();
 
      const refs = [
        generalInfoRef,
        enrollmentRef,
        ...(renewalCase.products
          ?.split(",")
          .map((product) => product.trim().toLowerCase())
          .includes("fsa")
          ? [fsaRef]
          : []),
        ...(renewalCase.products
          ?.split(",")
          .map((product) => product.trim().toLowerCase())
          .includes("hra")
          ? [hraRef]
          : []),
        ...(renewalCase.products
            ?.split(",")
            .map((product) => product.trim().toLowerCase())
            .includes("lsa")
            ? [lsaRef]
            : []),
      ];
 
      let isValid = true;
 
      for (let ref of refs) {
        if (ref.current && typeof ref.current.validateAll === "function") {
          const valid = ref.current.validateAll();
 
          if (!valid) {
            isValid = false;
          }
        }
      }
 
      if (isValid) {
        try {
          // await axios.post(
          //   `${config.API_URL}/RenewalPortal/EBFormSubmission/${caseId}`
          // );
 
          const patchDocument = [
            { op: "replace", path: "/eBSubmissionStatus", value: "Submitted" },
            { op: "replace", path: "/submittedBy", value: username },
            { op: "replace", path: "/submittedAt", value: new Date().toISOString() },
            {
              op: "replace",
              path: "/summaryURL",
              value: `${config.WEB_URL}/EmployeeBenefitsSummary/${caseId}`,
            },
          ];
          const url = `${config.API_URL}/RenewalCases/${caseId}`;
          await axios.patch(url, patchDocument);
          ebSubmittedAlert(caseId, navigate);
 
          //excel
          const fetchPlansData = async (url) => {
            try {
              const response = await axios.get(url);
              return response.data;
            } catch (error) {
              if (error.response && error.response.status === 404) {
                console.warn(`Data not found for URL: ${url}`);
                return []; // Return an empty array for 404 responses
              } else {
                console.error(`Error fetching data from ${url}:`, error.message);
                throw error; // Re-throw for critical errors
              }
            }
          };
          
          const responses = await Promise.all([
            fetchPlansData(`${config.API_URL}/EBFSAPlans/ByCaseId/${caseId}`),
            fetchPlansData(`${config.API_URL}/EBDCAPlans/ByCaseId/${caseId}`),
            fetchPlansData(`${config.API_URL}/EBLPFSAPlans/ByCaseId/${caseId}`),
            fetchPlansData(`${config.API_URL}/EBHRAPlans/ByCaseId/${caseId}`),
            fetchPlansData(`${config.API_URL}/EBLSAPlans/ByCaseId/${caseId}`),
          ]);
          
          // Extract plans from responses
          const fsaPlans = Array.isArray(responses[0]) ? responses[0] : [responses[0]];
          const dcaPlans = Array.isArray(responses[1]) ? responses[1] : [responses[1]];
          const lpfsaPlans = Array.isArray(responses[2]) ? responses[2] : [responses[2]];
          const hraPlans = Array.isArray(responses[3]) ? responses[3] : [responses[3]];
          const lsaPlans = Array.isArray(responses[4]) ? responses[4] : [responses[4]];
          
          if ([...fsaPlans, ...dcaPlans, ...lpfsaPlans, ...hraPlans, ...lsaPlans].length === 0) {
            console.error("No plans data available for export.");
            return;
          }
          
 
          // Create a new workbook
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet("Plans");
 
          // Header styles
          const headerStyle = {
            font: { bold: true },
            // alignment: { vertical: "center" },
            alignment: {
              vertical: "center",
              // Rotate text vertically
            },
            fill: {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FF28B463" },
            },
            border: {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            },
          };
 
          // Subheader styles
          const subHeaderStyle = {
            font: { bold: true },
            fill: {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FF28B463" },
            },
            border: {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            },
          };
 
          const subStyle = {
            fill: {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFE5D8A1" },
            },
            border: {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            },
          };
 
          // Add headers as a vertical column (header in one column, data in the next)
          const headers = [
            "Company Name",
            "Employer ID",
            "Employee ID",
            "Dependent ID",
          ];
 
          const data = [
            renewalCase.employerName, // Corresponding data for "Company Name"
            renewalCase.bencode, // Corresponding data for "Employer ID"
            "Please use Employee SSN", // Corresponding data for "Employee ID"
            "Please use Dependent SSN", // Corresponding data for "Dependent ID"
          ];
 
          // Loop through headers and data to add them in the same structure
          headers.forEach((header, index) => {
            const row = worksheet.addRow([header, data[index]]);
 
            // Apply styles for headers
            row.getCell(1).style = headerStyle; // Header column style (green background)
 
            // Apply styles for data
            row.getCell(2).style = subStyle; // Data column style (cream background)
          });
          subStyle;
          //   });
 
          // Add Plan Information headers
          worksheet.addRow([]);
          worksheet
            .addRow([
              "Plan Name",
              "Plan ID",
              "Action Type",
              "Plan Start Date",
              "Plan End Date",
            ])
            .eachCell((cell) => {
              cell.style = subHeaderStyle;
            });
 
          // Default mapping for Plan Name, Plan ID, and Action Type
          const defaultPlanData = {
            fsa: {
              planName: "Flexible Spending Account",
              planId: "FSA",
              actionType: "FSA",
            },
            dca: {
              planName: "Dependent Care Account",
              planId: "DCA",
              actionType: "DCA",
            },
            hra: {
              planName: "Healthcare Reimbursement Account",
              planId: "HRA",
              actionType: "",
            },
            lsa: {
              planName: "Lifestyle Savings Account",
              planId: "LSA",
              actionType: "",
            },
            lpfsa: {
              planName: "Limited Purpose Flexible Spending Account",
              planId: "LPF",
              actionType: "LPF",
            },
          };
 
          // Add plan rows
          [...fsaPlans, ...dcaPlans, ...lpfsaPlans, ...hraPlans, ...lsaPlans].forEach(
            (plan) => {
              if (plan.carrierName && plan.planName) {
                defaultPlanData.hra.actionType = `${plan.carrierName}-${plan.planName}`;
                defaultPlanData.lsa.actionType = `${plan.carrierName}-${plan.planName}`;
              } else {
                defaultPlanData.hra.actionType = "Unknown HRA Action Type"; // Fallback if missing data
                defaultPlanData.lsa.actionType = "Unknown LSA Action Type";
              }
 
              const planDetails = plan.fsaPlanStartDate
                ? defaultPlanData.fsa
                : plan.dcaPlanStartDate
                ? defaultPlanData.dca
                : plan.lpfsaPlanStartDate
                ? defaultPlanData.lpfsa
                : defaultPlanData.hra;
 
              const planStartDate =
                plan.fsaPlanStartDate ||
                plan.dcaPlanStartDate ||
                plan.lpfsaPlanStartDate ||
                plan.planStartDate;
              const planEndDate =
                plan.fsaPlanEndDate ||
                plan.dcaPlanEndDate ||
                plan.lpfsaPlanEndDate ||
                plan.planEndDate;
 
              worksheet
                .addRow([
                  planDetails.planName,
                  planDetails.planId,
                  planDetails.actionType,
                  planStartDate || "N/A",
                  planEndDate || "N/A",
                ])
                .eachCell((cell) => {
                  cell.style = subStyle;
                });
            }
          );
 
          // Add segmented funding information
          worksheet.addRow([]);
          worksheet.mergeCells("A15:D15");
          worksheet.getCell("A15").value =
            "DOES CLIENT HAVE SEGMENTED FUNDING BY DIVISION?";
          worksheet.getCell("A15").style = subHeaderStyle;
          worksheet.getCell("E15").value = "NO";
          worksheet.getCell("E15").style = subStyle;
          // Add divisions information
          worksheet.addRow([]);
          worksheet
            .addRow(["Divisions (REQUIRED FOR SEGMENTED FUNDING)"])
            .eachCell((cell) => {
              cell.style = subHeaderStyle;
            });
          worksheet.addRow(["n/a"]).eachCell((cell) => {
            cell.style = subStyle;
          });
 
          // Adjust column widths
          worksheet.columns.forEach((column) => {
            column.width = 25;
          });
 
          // Export to Excel
          const buffer = await workbook.xlsx.writeBuffer();
          const base64File = buffer.toString("base64");
 
          // Prepare the payload with file name and base64 encoded content
          // const payload = {
          //   fileName: "Plans_UI_Format.xlsx", // Specify your file name
          //   filePayload: base64File, // Base64 encoded file content
          // };
 
          const formData = new FormData();
          formData.append(
            "file",
            new Blob([buffer], { type: "application/octet-stream" }),
            "Plans_UI_Format.xlsx"
          ),
            formData.append(
              "filePayload",
              new Blob([buffer], { type: "application/octet-stream" }),
              "base64File"
            );
          console.log(formData);
          // Send the payload to your API
          await axios.post(
            `${config.API_URL}/RenewalPortal/EBFormSubmission/${caseId}`, // Replace with actual endpoint
            formData
 
            // {
            //   fileName: "filename.xlsx",
            //   filePayload: base64File,
            // }
          );
          const blob = new Blob([buffer], { type: "application/octet-stream" });
          saveAs(blob, "Plans_UI_Format.xlsx");
        } catch (error) {
          console.error("Error submitting renewal form:", error);
          console.error("Error exporting data:", error);
          onError(error);
        }
 
        setSubmitSuccess(true);
      } else {
        setSubmitError(
          "Please correct the highlighted errors before submitting."
        );
        setShowValidationMessage(true);
      }
    } catch (error) {
      console.error("Error saving plan changes or fetching plans:", error);
      setSubmitError(
        "There was an error while saving changes. Please try again."
      );
    }
  };


  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const disabledStatuses = ["closed", "cancelled", "closed non-response", "complete", "form submission"];
  const isDisableForUsers = disabledStatuses.includes(renewalCase?.caseStatus?.toLowerCase());



  if (!username) return (<Layout>
    <div className="confirmation-container mt-5">
      <Card className="confirmation-card shadow-lg p-3 mb-5 bg-white rounded">
        <div className="text-center mb-4">
          <Image src={ClarityLogo} alt="Company Logo" className="confirmation-logo" />
        </div>
  
        <Alert variant="danger" className="text-center">Please login from the portal </Alert>
  
  
  
      </Card>
    </div>
  </Layout>);



  return (
    <div>
      <CompanyLayout caseId={caseId} renewalCase={renewalCase}>
        <div className="row fixedHeader">
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div className="d-flex justify-content-start"></div>
              <div className="d-flex justify-content-center">
                <span id="page-title">
                  You are currently renewing benefits for <strong>{renewalCase?.employerName || " "}</strong>.
                </span>
              </div>
              <div className="d-flex justify-content-end">
                <span className="pt-1 me-2" id="autoSavedMessage"></span>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mb-1 d-flex justify-content-end">
            {showValidationMessage && (
              <span className="pt-1 me-2" id="validationMessage" style={{ color: 'rgb(255, 99, 71)' }}>
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i> Error: Please ensure all fields are complete.
              </span>
            )}
            <button
              type="button"
              className="btn btn-primary btn-sm mt-1 me-1 " onClick={() => handleOpenModal()}
              //disabled={renewalCase?.ebSubmissionStatus === 'Submitted' || isDisableForUsers}
              disabled={isDisableForUsers}
            >
              INVITE COLLABORATORS
            </button>
            <button
              type="button"
              className="btn btn-primary btn-sm mt-1 me-1 save-company-profile" onClick={saveAlert}
             //disabled={renewalCase?.ebSubmissionStatus === 'Submitted' || isDisableForUsers}
             disabled={isDisableForUsers}
            >
              SAVE
            </button>

            <button
              type="button"
              className="btn btn-success btn-sm mt-1 me-1"
              onClick={handleSubmit}
              //disabled={renewalCase?.ebSubmissionStatus === 'Submitted' || isDisableForUsers}
              disabled={isDisableForUsers || (renewalCase?.caseStatus === 'Awaiting Files' && renewalCase?.ebSubmissionStatus === 'Submitted')}
            >
              SUBMIT BENEFITS
            </button>
          </div>

          <div className="col-lg-12 progress-position">
            <div className="progress mb-3">
              {/* <div
                className="progress-bar progress-bar-success"
                role="progressbar"
                style={{ width: '22%' }}
              >
                <span id="totalProgress">22%</span>
              </div> */}
              <div
                className="progress-bar progress-bar-warning"
                role="progressbar"
                style={{ width: '100%' }}
              >
                <span id="pendingProgress"></span>
              </div>
            </div>
          </div>
        </div>

        <div id="page-content-wrapper">
          <Container fluid >
            <Row className="startingrow">
              <Col className="d-flex justify-content-between">
              <h5 className="cobra-section">EmployeeBenefits</h5>
              {renewalCase?.ebSubmissionStatus === 'Submitted' && (
              <span className="pt-1 me-2"  style={{ color: 'rgb(103, 156, 91)' }}>
              <strong>
                Renewal form submitted {renewalCase?.submittedAt
  ? new Date(renewalCase.submittedAt).toLocaleDateString('en-US')
  : ''}
  </strong> 
              </span>
              )}
              </Col>
              <GeneralInfo ref={generalInfoRef} caseId={caseId} renewalCase={renewalCase} fsaDataRef={fsaRef} isDisableForUsers={isDisableForUsers} onError={handleError} setInformationProvider={setInformationProvider} />
              <Enrollment ref={enrollmentRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError} />
              <FSA ref={fsaRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError} informationProvider={informationProvider}/>
              <HRA ref={hraRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} initialFormValues={{}} onError={handleError} />
              <LSA ref={lsaRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} initialFormValues={{}} onError={handleError} />

            </Row>
          </Container>
          {isModalOpen && <ChangeContact caseId={caseId} onClose={handleCloseModal} action='invite' companyName={renewalCase?.employerName} caseType={renewalCase?.caseType} />}
          
          {showPopup && 
            <SurveyMonkey isOpen={true}
              onClose={handleCloseModalOne}
              userEmail={renewalCase?.renewalContactEmail}/>
          }
          
            
        </div>
      </CompanyLayout>
    </div >
  );
}

export default EmployeeBenefits;
